import { Reveal, SectionHead } from "./shared";
import { IMAGES } from "../data/content";

const PILLARS = [
    {
        title: "Solar",
        description: "Engineering and infrastructure support for solar power projects — from electrical works to grid connection infrastructure.",
        image: IMAGES.solarAerial,
        alt: "Aerial view of a utility-scale solar park",
        tag: "SOLAR / EPC SUPPORT",
    },
    {
        title: "Wind",
        description: "Infrastructure and execution support for wind energy projects, including associated electrical and transmission works.",
        image: IMAGES.windDusk,
        alt: "Wind turbines operating above a reservoir at dusk",
        tag: "WIND / EPC SUPPORT",
    },
];

export const Renewable = () => (
    <section data-testid="renewable-section" className="relative bg-vec-mist py-16 lg:py-32 border-y border-vec-border">
        <div className="vec-container">
            <SectionHead
                index="SEC 05"
                eyebrow="Renewable Energy"
                title="Building the Next Generation of Energy Infrastructure"
                sub="Renewable energy is part of VEC's broader power-infrastructure engineering capability — connecting generation to the grid."
            />

            <div className="mt-10 lg:mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                {PILLARS.map((p, i) => (
                    <Reveal key={p.title} delay={i * 0.1}>
                        <article
                            data-testid={`renewable-${p.title.toLowerCase()}-card`}
                            className="group relative overflow-hidden border border-vec-border bg-vec-charcoal aspect-[4/3] sm:aspect-[16/10]"
                        >
                            <img
                                src={p.image}
                                alt={p.alt}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover opacity-90 transition-all duration-700 ease-out group-hover:scale-[1.03] group-hover:opacity-100"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-vec-charcoal/95 via-vec-charcoal/30 to-transparent" aria-hidden="true" />
                            <div className="relative h-full flex flex-col justify-end p-6 sm:p-8">
                                <span className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-vec-green-bright">
                                    {p.tag}
                                </span>
                                <h3 className="mt-2 font-display text-2xl sm:text-3xl font-semibold uppercase tracking-tight text-white">
                                    {p.title}
                                </h3>
                                <p className="mt-2 max-w-md text-sm leading-relaxed text-white/75">
                                    {p.description}
                                </p>
                                <span className="mt-4 block h-[2px] w-10 bg-vec-green-bright transition-all duration-500 group-hover:w-24" aria-hidden="true" />
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
